<template>
    <div>
        <div class="search-group">
            <span>应用id：</span>
            <a-input
                v-model="params.applicationId"
                size="small"
                style="width: 200px; height: 40px"
            />
            <span>应用名称：</span>
            <a-input
                v-model="params.applicationName"
                size="small"
                style="width: 200px; height: 40px"
            />
            <span>服务商名称：</span>
            <a-input
                v-model="params.providerName"
                size="small"
                style="width: 200px; height: 40px"
            />
            <a-button @click="handleSearch" type="primary" style="height:40px;width:80px;margin-left:20px">查询</a-button>
        </div>

        <template>
            <a-table
                :columns="columns"
                :data-source="data"
                :pagination="pagination"
                @change="handleTableChange"
                style="background:white;padding:50px"
            >
                <a slot="operation" slot-scope="text, record">
                    <!-- <a-button @click="goToDetail(record)">添加</a-button> -->
                    <span @click="goToDetail(record)" class="ml10"><a>添加</a></span>
                </a>
            </a-table>
        </template>
    </div>
</template>

<script>
const columns = [
    {
        title: "应用ID",
        dataIndex: "applicationId",
        key: "applicationId",
    },

    {
        title: "应用名称",
        dataIndex: "applicationName",
        key:"applicationName"
    },
        {
        title: "服务商名称",
        dataIndex: "providerName",
        key: "providerName",
    },
    {
        title: "产品类型",
        dataIndex: "industryLabelNames",
        key: "industryLabelNames",
    },
    {
        title: "应用类型",
        dataIndex: "applicationTypeLabelName",
        key: "applicationTypeLabelName",
    },
    {
        title: "操作",
        ellipsis: true,
        scopedSlots: { customRender: "operation" },
    },
];

export default {
    data() {
        return {
            data: [],
            columns,
            params: { pageNum: 1, pageSize: 10 },
            pagination: {
                total: 0,
                pageSize: 10,//每页中显示10条数据
                showSizeChanger: true,
                pageSizeOptions: ["10", "20", "50", "100"],//每页中显示的数据
                showTotal: total => `共有 ${total} 条数据`,  //分页中显示总的数据
            },
        };
    },
    components: {},
    methods: {
        handleTableChange(pagination) {
            console.log()
            this.pagination.current = pagination.current;
            this.pagination.pageSize = pagination.pageSize;
            this.params.pageNum = pagination.current;
            this.params.pageSize = pagination.pageSize;
            this.getList();
        },
        goToDetail(t) {
            this.$emit("ondetail", "Detail", t);
        },
        getList() {
            this.$api.customerManage
                .helpCustomerOrdersList(this.params)
                .then((response) => {
                    this.data = response.result.list;
                    this.pagination.total = parseInt(response.result.total)
                });
        },
        handleSearch() {
            // if(this.params.accountId){
            //     this.params.accountId = Number(this.params.accountId)
            // }
            // console.log(this.params)
            this.getList();
        },
    },
    mounted() {
        this.getList();
    },
};
</script>

<style scoped>
.search-group {
    margin-bottom: 10px;
    height: 80px;
    background: white;
    display: flex;
    align-items: center;
    padding: 20px;
}
</style>
